import {
  belongsTo,
  createServer,
  Model,
  Response,
  JSONAPISerializer,
} from 'miragejs';
import * as fixtures from './fixtures';
import { tokens } from './fixtures';
import { apiBaseUrl, apiNameSpace } from '../constants';
import { camelCase } from 'lodash';

const OK = new Response(
  200,
  {},
  {
    data: {},
    responseCode: 200,
  }
);

export function makeServer({ environment = 'test' }) {
  const server = createServer({
    environment,

    models: {
      account: Model,
      customer: Model,
      event: Model,
      payment: Model,
      transaction: Model,
      transfer: Model.extend({
        account: belongsTo(),
        customer: belongsTo(),
        destinationAccount: belongsTo('account'),
      }),
      virtualNuban: Model,
      webhook: Model,
    },

    serializers: {
      application: JSONAPISerializer.extend({
        keyForAttribute(attr) {
          return camelCase(attr);
        },
        keyForRelationship(attr) {
          return camelCase(attr);
        },
      }),
    },
    fixtures: {
      accounts: fixtures.accounts,
      customers: fixtures.customers,
      events: fixtures.events,
      transactions: fixtures.transactions,
      transfers: fixtures.transfers,
      payments: fixtures.payments,
      virtualNubans: fixtures.virtualNubans,
      webhooks: fixtures.webhooks,
    },

    routes() {
      this.urlPrefix = apiBaseUrl;
      this.namespace = apiNameSpace;

      this.resource('accounts');
      this.resource('customers');
      this.resource('events');
      this.resource('payments');
      this.resource('transactions');
      this.resource('transfers');
      this.resource('virtual-nubans');
      this.resource('webhooks');
      this.get('organizations/tokens', () => {
        let ok = new Response(
          200,
          {},
          {
            data: tokens,
            responseCode: 200,
          }
        );
        return ok;
      });
      this.post('/auth/login', () => {
        /*
        //(schema, request) => {
        let attrs = JSON.parse(request.requestBody);
        let invalidRequest = new Response(
          400,
          {
            'Content-Type': 'application/json;charset=ISO-8859-1',
          },
          {
            message: 'Invalid Request format',
            responseCode: 400,
          }
        );

        let notAuthorised = new Response(401, {}, { responseCode: 401 });
        */

        let ok = new Response(
          200,
          {},
          {
            data: {
              id: '0',
              type: '',
              attributes: {
                accessToken:
                  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.hLUGdzJvD9lUAEA-Y7Hg2vAtnSfDUtbQYePFFtXktmE',
              },
              relationships: {
                organization: {
                  data: {
                    id: '16534918589610-anc_og',
                    type: 'Organization',
                  },
                },
              },
            },
            responseCode: 200,
          }
        );
        return ok;
      });

      this.post('/signup', () => {
        return OK;
      });

      this.post('auth/verify-email', () => {
        return OK;
      });
    },
  });

  return server;
}
